'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dialog = require('../../dialog/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setReleaseNotesItem = function setReleaseNotesItem(props) {
    window.localStorage.setItem(props.RELEASE_NOTES_ITEM, props.currentVersion);
    props.setShowReleaseNotes(false);
};

var getReleases = function getReleases(props) {
    var releases = [];

    (0, _lodash.forOwn)(props.releaseNotes[props.translationKey], function (note, version, index) {
        var notePoints = note.content.map(function (point, i) {
            return _react2.default.createElement(
                'li',
                { key: version + '-' + index + '-note-' + i },
                point
            );
        });

        releases.push(_react2.default.createElement(
            'div',
            { className: 'form-group', key: version + '-' + index + '-note' },
            _react2.default.createElement(
                'h5',
                null,
                'v ' + version,
                _react2.default.createElement(
                    'span',
                    { className: 'pull-right text-muted' },
                    (0, _moment2.default)(note.date, 'DD.MM.YYYY').format('L')
                )
            ),
            _react2.default.createElement(
                'ul',
                null,
                notePoints
            )
        ));
    });

    return releases;
};

var getHeader = function getHeader(translations) {
    return _react2.default.createElement(
        'span',
        null,
        translations['whatsNew'] ? translations['whatsNew'] : 'What`s new?'
    );
};

var getBody = function getBody(props) {
    return _react2.default.createElement(
        'div',
        null,
        getReleases(props)
    );
};

var getFooter = function getFooter(props) {
    return _react2.default.createElement(
        'button',
        { 'data-component': 'CloseButton', type: 'button', className: 'btn btn-default',
            onClick: function onClick() {
                return setReleaseNotesItem(props);
            } },
        props.translations['close'] ? props.translations['close'] : 'Close'
    );
};

var ReleaseNotesDialog = function ReleaseNotesDialog(props) {
    return _react2.default.createElement(_Dialog2.default, {
        show: props.showReleaseNotes,
        header: getHeader(props.translations),
        body: getBody(props),
        footer: getFooter(props),
        onHide: function onHide() {
            return setReleaseNotesItem(props);
        }
    });
};

ReleaseNotesDialog.propTypes = {
    showReleaseNotes: _propTypes2.default.bool.isRequired,
    setShowReleaseNotes: _propTypes2.default.func.isRequired,
    translations: _propTypes2.default.object.isRequired,
    translationKey: _propTypes2.default.string.isRequired,
    releaseNotes: _propTypes2.default.object.isRequired,
    currentVersion: _propTypes2.default.string.isRequired,
    RELEASE_NOTES_ITEM: _propTypes2.default.string.isRequired
};

exports.default = ReleaseNotesDialog;